
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class GalacticCoreEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time, width, height } = pc;
         const curTime = time * config.parallaxSpeed;
        const scale = config.parallaxScale || 1.0;

        ctx.fillStyle = pc.color;

        const draw = () => {
             // Central blaze
             const coreR = 200 * scale;
             const grad = ctx.createRadialGradient(0, 0, 0, 0, 0, coreR);
             grad.addColorStop(0, pc.color);
             grad.addColorStop(1, 'transparent');
             
             ctx.save();
             ctx.globalAlpha *= 0.3 / (layerIndex + 1);
             ctx.fillStyle = grad;
             ctx.beginPath();
             ctx.ellipse(0, 0, coreR * 2, coreR * 0.8, -curTime * 0.1, 0, Math.PI * 2);
             ctx.fill();
             
             // Swirling dust lanes (approx)
             const lanes = Math.floor(5 * (config.parallaxComplexity || 1.0));
             for (let i = 0; i < lanes; i++) {
                 ctx.rotate(curTime * 0.05 + i);
                 ctx.beginPath();
                 ctx.lineWidth = 10 * scale;
                 ctx.globalAlpha *= 0.2;
                 ctx.arc(0, 0, coreR * (1 + i * 0.5), 0, Math.PI);
                 ctx.stroke();
             }
             ctx.restore();
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
